import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "./Rightpart.css";
import CurrencyRupeeOutlinedIcon from "@mui/icons-material/CurrencyRupeeOutlined";
import { fetchUserAppAPI } from "../../utils/api";
import { ShimmerTable } from "react-shimmer-effects";

export default function Myordertable() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) {
      navigate("/login");
      return;
    }
    const parsedUser = JSON.parse(storedUser);

    const fetchOrders = async () => {
      try {
        setLoading(true);
        const res = await fetchUserAppAPI("equipments-list-order", {
          method: "POST",
          body: JSON.stringify({ user_id: parsedUser.user_id }),
        });
        if (res && res.status === 200 && Array.isArray(res.result)) {
          setOrders(res.result);
        }
      } catch (err) {
        console.error("Error fetching payment history:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [navigate]);

  const totalSpent = orders.reduce(
    (sum, o) => sum + (parseFloat(o.order_grand_total) || 0),
    0,
  );
  const pendingOrdersCount = orders.filter(
    (o) => o.order_payment_status === "Pending",
  ).length;
  const lastOrderDate =
    orders.length > 0 && orders[0].order_created
      ? new Date(orders[0].order_created).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
      : "N/A";

  return (
    <div className="outer-div-right">
      <div className="dashbord-right-section">
        <div className="content-dashborad-outer outer_main_payment_pg">
          <div className="address-manager ">
            <div className="box-top">
              <div className="sr-number">
                <h4>Payment & Invoice History</h4>
              </div>
            </div>
            <div className=" billing-text">
              <div className="table-dashbord table-responsive">
                {loading ? (
                  <div className="p-3">
                    <ShimmerTable row={4} col={6} />
                  </div>
                ) : orders.length === 0 ? (
                  <div className="text-center py-4 text-muted">
                    No payment history available.
                  </div>
                ) : (
                  <table>
                    <thead>
                      <tr>
                        <th>Order No</th>
                        <th>Date</th>
                        <th>Payment Method</th>
                        <th>Amount</th>
                        <th>Payment Status</th>
                        <th>Order Status</th>
                      </tr>
                    </thead>

                    <tbody>
                      {orders.map((order) => {
                        const createdDate = order.order_created
                          ? new Date(order.order_created).toLocaleDateString(
                              "en-IN",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              },
                            )
                          : "-";

                        return (
                          <tr key={order.order_id}>
                            <td>
                              {" "}
                              <Link to="/myorderDetail">
                                <strong>#{order.order_no}</strong>
                              </Link>
                            </td>
                            <td>{createdDate}</td>
                            <td>{order.order_payment_method || "COD"}</td>
                            <td>
                              ₹
                              {parseFloat(
                                order.order_grand_total || 0,
                              ).toLocaleString("en-IN")}
                            </td>
                            <td>
                              <span
                                className={`status ${(order.order_payment_status || "Pending").toLowerCase()}`}
                              >
                                {order.order_payment_status || "Pending"}
                              </span>
                            </td>
                            <td>
                              <span
                                className={`status ${(order.order_status || "Pending").toLowerCase()}`}
                              >
                                {order.order_status || "Pending"}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
